import request from '#/utils/request';

/**
 * 刪除待指定 物料序號。
 * DELETE `/aftersales/sn-product-mapping/{id}`
 * 成功為 message，沒有 data。
 *
 * @param {string} id
 */
export async function deleteSnProductMapping(id) {
  const { data: raw } = await request.delete(`/aftersales/sn-product-mapping/${id}`);
  return {
    message: raw?.message,
    route: raw?.route,
  };
}
